import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const moeRouterComponent: ComponentDef = {
  id: 'moe-router',
  name: 'MoE Router',
  description: 'Mixture-of-Experts routing: a gating network dispatches tokens to top-k experts. Supports token-choice, expert-choice, and switch routing.',
  category: 'component',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'n_experts', label: 'Experts', type: 'number', default: 4, min: 2, max: 128, step: 1 },
    { name: 'top_k', label: 'Top-K', type: 'number', default: 2, min: 1, max: 8, step: 1 },
    {
      name: 'routing',
      label: 'Routing strategy',
      type: 'select',
      default: 'token-choice',
      options: [
        { label: 'Token Choice (top-k)', value: 'token-choice' },
        { label: 'Expert Choice', value: 'expert-choice' },
        { label: 'Switch (top-1)', value: 'switch' },
      ],
    },
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const n_experts = Number(params.n_experts);
    const top_k = Number(params.top_k);
    const routing = String(params.routing || 'token-choice');

    const g = new GraphBuilder();
    g.input('x', [seq_len, d_model]);
    g.linear('gate_logits', 'x', [d_model, n_experts]);

    if (routing === 'switch') {
      g.softmax('gate_probs', 'gate_logits', -1);
      g.router('topk_gate', 'gate_probs', [seq_len, 1]);
    } else if (routing === 'expert-choice') {
      g.softmax('gate_probs', 'gate_logits', 0);
      g.transpose('gate_t', 'gate_probs', [n_experts, seq_len], 'T');
      g.router('expert_select', 'gate_t', [n_experts, top_k]);
    } else {
      g.softmax('gate_probs', 'gate_logits', -1);
      g.router('topk_gate', 'gate_probs', [seq_len, top_k]);
    }

    const expertIds: string[] = [];
    for (let i = 0; i < n_experts; i++) {
      const id = `expert_${i}`;
      g.expert(id, 'x', [seq_len, d_model], i + 1);
      expertIds.push(id);
    }

    if (expertIds.length === 1) {
      g.output('out', expertIds[0]);
    } else {
      let sumId = expertIds[0];
      for (let i = 1; i < expertIds.length; i++) {
        const next = i === expertIds.length - 1 ? 'weighted_sum' : `sum_${i}`;
        g.add(next, sumId, expertIds[i]);
        sumId = next;
      }
      g.output('out', sumId);
    }

    return g.build();
  }
};
